import './App.scss';
import { Provider } from 'react-redux';
import store from './main/store/store';
import { ThemeProvider } from '@mui/material';
import { theme } from './main/layout/theme';
import checkmateApi from './main/axios/checkmateApi';
import ToastMessage from './library/components/ToastMessage/ToastMessage';
import React, { useEffect } from 'react';
import { LicenseManager } from  'ag-grid-enterprise'
import AppRouter from './main/routes/AppRouter';
import { assetMap } from './library/util/assetMap';
import { getMsalInstance } from './main/services/msalService';
import { registerLoadingInterceptors } from './main/axios/loadingInterceptors';

// CHKM-4023: registered at module scope, NOT from App's mount effect. React runs
// child effects before parent effects, so AppRouter's mount effect (which dispatches
// callGetLoggedInUser on a cookie-hydrated authToken) would fire before App's effect
// registered these — and axios snapshots both interceptor chains synchronously at
// dispatch, so a late registration cannot retro-apply to the in-flight request. The
// result was a bootstrap request with no global error interceptor, silently disabling
// the app's only automatic expired-token logout (loadingInterceptors.ts:52).
// Module scope also makes this immune to re-renders, StrictMode double-invocation,
// and any future second App instance: the module body evaluates exactly once.
registerLoadingInterceptors(checkmateApi, store.dispatch);

function App() {

  useEffect(() => {
    LicenseManager.setLicenseKey('Using_this_{AG_Grid}_Enterprise_key_{AG-067133}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{PSI}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{PSI_Advantage}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{PSI_Advantage}_need_to_be_licensed___{PSI_Advantage}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{17_November_2025}____[v3]_[01]_MTc2MzMzNzYwMDAwMA==c0f32d2af6bde52a45385f04ee7a974f');
  }, []);

  useEffect(() => {
    document.title = assetMap('appTitle');
    const link = document.createElement('link');
    link.rel = "apple-touch-icon shortcut icon";
    link.href = assetMap('titleLogo');
    document.head.appendChild(link);
  }, []);

  // Initialize MSAL on app startup
  useEffect(() => {
    const initializeMsal = async () => {
      try {
        await getMsalInstance();
      } catch (error) {
        console.error('Error initializing MSAL on app startup:', error);
      }
    };
    initializeMsal();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <ToastMessage />
        <AppRouter />
      </Provider>
    </ThemeProvider>
  );
}

export default App;
